module.exports = __webpack_public_path__ + "static/media/restart_nav_icn.6ba89e19.svg";